const PropertySettingsKpisTab = () => {
  return <div>TODO kpis</div>;
};

export default PropertySettingsKpisTab;
